(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/models/ticket.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/models/ticket.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.numbergames.game_model.models.Ticket = svs.numbergames.core.NumbergamesModel.extend({
  defaults() {
    return {
      text: '',
      price: 0,
      quantity: 0,
      isDisabled: false,
      imgUrl: '',
      skin: null,
      ticketData: undefined
    };
  },
  parse(attrs) {
    const ticket = svs.ticketgames.gameHandler.getPackageGame();
    if (!ticket) {
      svs.numbergames.game_model.logger.warn('No ticket found');
      return {};
    }
    const _ticket$packageGameCo = ticket.packageGameConfig,
      skinUrl = _ticket$packageGameCo.skinUrl,
      skin = _ticket$packageGameCo.skin,
      price = ticket.price;
    const ticketText = svs.numbergames.game_model.data.config.text.replace(/(?:\r\n|\r|\n)/g, '<br>');
    attrs.price = price;
    attrs.imgUrl = skinUrl;
    attrs.skin = skin;
    attrs.text = ticketText;
    attrs.ticketData = _objectSpread(_objectSpread({}, ticket), {}, {
      product: 'Triss'
    });
    return attrs;
  }
});

 })(window);